import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentResponse = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // URLSearchParams nos ayuda a leer los parámetros de la URL fácilmente
    const params = new URLSearchParams(location.search);
    const transactionState = params.get('transactionState');
    const referenceCode = params.get('referenceCode'); // <-- Obtenemos el código de referencia

    // PayU utiliza códigos numéricos para el estado de la transacción:
    // 4 = Aprobada
    // 6 = Rechazada
    // 5 = Pendiente
    // Otros...

    if (transactionState === '4') { // Si la transacción fue APROBADA
      // Verificamos si el referenceCode indica que es un ebook
      if (referenceCode && referenceCode.includes('_ebook')) {
        navigate('/success-ebook'); // Redirige a la página de éxito del ebook
      } else {
        // Por defecto, o si es un curso, redirige a la página de éxito principal
        navigate('/success');
      }
    } else {
      // Para cualquier otro estado (rechazado, pendiente, etc.), redirige a la página de fallo
      navigate('/rejected');
    }

  }, [location.search, navigate]);

  // Muestra un estado de carga mientras se realiza la redirección
  return (
    <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#111827',
        color: 'white',
    }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>Verificando tu pago...</h1>
    </div>
  );
};

export default PaymentResponse;

